import Header from "../components/header";
import PageTitle from "../components/page-title";
import { requestPasswordReset } from "../functions/requestPasswordReset";
import ResetPasswordmodule from "../components/reset-password-module";

function ResetPassword(){  
    const handleClick =() => {
        window.location.href = "/login"
    }
    return <>
    <Header CTA='Log in' functionForButton={handleClick}></Header>
    <ResetPasswordmodule></ResetPasswordmodule>
    </>
}
    
export default ResetPassword;